<div *ngIf="hasPackageAlready" class="has-package-already message-bar">
  <div class="inner-message" [translate]="'eos-tv-shop-ii.lbl.already-subscribed'"></div>
</div>
<div *ngIf="isDowngrade" class="has-package-already is-downgrade message-bar">
  <div class="inner-message" [translate]="'eos-tv-shop-ii.text.sorry-you-cant-order-a-pack'"></div>
  <div class="inner-extra" [translate]="'eos-tv-shop-ii.text.questions-call-us-nr'"></div>
</div>
<div *ngIf="hasDayPass && !hasPackageAlready" class="has-daypass-trial-already message-bar-daypass-trial">
	<span class="inner-message" [translate]="'eos-tv-shop-ii.lbl.sorry-daypass-active-light'"></span> &nbsp;
  <span class="inner-bold" [translate]="'eos-tv-shop-ii.lbl.sorry-daypass-active-bold'"></span>
</div>
<div *ngIf="hasTrial" class="has-daypass-trial-already message-bar-daypass-trial">
	<span class="inner-message" [translate]="'eos-tv-shop-ii.text.sorry-trial-active-light'"></span> &nbsp;
  <span class="inner-bold" [translate]="'eos-tv-shop-ii.lbl.sorry-daypass-active-bold'"></span>
</div>
